import PrincipalsScene from '../scenes/PrincipalsScene';

const routes = [
  {
    path: '/principals/*',
    component: PrincipalsScene,
    exact: false,
    menuName: 'allUsers',
    hasSomeRights: [
      'ORGANISATIONS.MANAGE.ALL',
      'ORGANISATIONS.MANAGE.ALL.EXCEPTSYSTEMORGS',
      'ORGANISATIONS.READ.ALL',
      'ORGANISATIONS.READ.ALL.EXCEPTSYSTEMORGS',
    ],
    isActiveRoute: currentLocation => currentLocation.toLowerCase().startsWith('/principals'),
  },
];

export default routes;
